export default __webpack_public_path__ + "static/media/check.b4b437b7.svg";